import { LockKeyhole } from "lucide-react";
import type { ReactNode } from "react";

const logoUrl = "https://www.melhot.com.br/cdn/shop/files/Gemini_Generated_Image_bk8fkxbk8fkxbk8f_180x@2x.png?v=1786394801";

const isEmbedded = typeof window !== "undefined" && (window.location.pathname.includes("/cart") || window.location.pathname.includes("/pages/checkout") || window.parent !== window);

export function CheckoutLayout({ main, aside }: { main: ReactNode; aside: ReactNode }) {
  return (
    <main className="min-h-screen bg-white text-ink">
      {!isEmbedded && (
        <header className="border-t-4 border-hot bg-white shadow-sm">
          <div className="relative mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-5">
            <a href="https://www.melhot.com.br/" className="inline-flex items-center">
              <img src={logoUrl} alt="MelHot" className="h-10 w-auto sm:h-12" />
            </a>
            <div className="flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-200 px-3 py-1 text-xs font-bold text-emerald-700">
              <LockKeyhole size={14} className="text-emerald-600" />
              <span className="hidden sm:inline">Compra 100% Segura & Discreta</span>
              <span className="sm:hidden">100% Discreto</span>
            </div>
          </div>
        </header>
      )}

      <div className="mx-auto grid max-w-6xl gap-0 px-0 py-0 sm:px-5 lg:grid-cols-[minmax(0,1fr)_390px] lg:gap-10 lg:py-5">
        <aside className="order-1 bg-white lg:order-2 lg:sticky lg:top-6 lg:z-20 lg:h-fit">{aside}</aside>
        <section className="order-2 min-w-0 lg:order-1">{main}</section>
      </div>

      <div className="h-8" />
    </main>
  );
}
